import ofertaReferidor from "@/config/brands/ofertaDigital";

describe("ofertaReferidor", () => {
  it("should have a googleAnalyticsId", () => {
    expect(ofertaReferidor.googleAnalyticsId).toBe("UA-141672014-1");
  });

  it("should have a pasos object", () => {
    expect(typeof ofertaReferidor.pasos).toBe("object");
  });
});
